export const getFirstAndLastWords = (name: string) => {
  const words = name.split(' ');
  return [words[0], words[words.length - 1]];
};

// Given name such as "Firstname Lastname", return "FL"

export const getInitialsFromName = (name: string) =>
  getFirstAndLastWords(name)
    .map(n => n[0])
    .join('')
    .toUpperCase();
